import { BlockCheckoutStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { t } from "@redotech/redo-i18n";
import { FrontendStepType, PartialWithRequiredType } from "..";

export const blockCheckoutStepType: FrontendStepType<
  PartialWithRequiredType<BlockCheckoutStep>
> = {
  type: "standard",
  valid: (_) => true,
  selectable: (_) => true,
  inspectorFactory: (_props) => ({
    header: {
      title: t("Block checkout"),
      subtitle: t(
        "This step blocks the checkout process. Customers reaching this step will not be able to complete their purchase as no shipping options will be available for their physical products.",
      ),
    },
    sections: [],
  }),
};
